import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useMemo } from 'react';

var getImageUrl = function getImageUrl(url, params) {
  var queryParameters = new URLSearchParams(Object.entries(params));
  return "".concat(url, "?").concat(queryParameters);
};

var emptyArray = [];
/**
 * A hook to generate the image urls for the different image sizes
 * @param url - The path to the image
 * @param options.width - The width of the image
 * @param options.height - The height of the image
 * @param options.ext - The extension of the image
 * @param options.additionalImages - An array of additional images to generate
 * @returns The array of generated image urls
 */

var useContentfulImage = function useContentfulImage(url, options) {
  var width = options.width,
      height = options.height,
      _options$additionalIm = options.additionalImages,
      additionalImages = _options$additionalIm === void 0 ? emptyArray : _options$additionalIm;
  return useMemo(function () {
    if (!url) {
      return null;
    }

    var generatedImagesUrls = [getImageUrl(url, {
      w: width,
      h: height,
      fm: options.ext
    })];

    for (var i = 0; i < additionalImages.length; i++) {
      var _additionalImages$i = additionalImages[i],
          ext = _additionalImages$i.ext,
          multiplier = _additionalImages$i.multiplier;
      var dimensionParams = multiplier ? {
        w: width * multiplier,
        h: height * multiplier
      } : {};
      var extParam = ext ? {
        fm: ext
      } : {};
      var newUrl = getImageUrl(url, _objectSpread(_objectSpread({}, extParam), dimensionParams));
      generatedImagesUrls.push(newUrl);
    }

    return generatedImagesUrls;
  }, [url, width, height, emptyArray]);
};

export default useContentfulImage;